const DELETE_ACTIVITY_ADD_ONS = 'DELETE_ADD_ONS';
const DELETE_ACTIVITY_MANDATORY_FEES = 'DELETE_MANDATORY_FEES';
const DELETE_RELATED_ACCOMMODATIONS = 'DELETE_RELATED_ACCOMMODATIONS';
const DELETE_RELATED_ACTIVITIES = 'DELETE_RELATED_ACTIVITIES';
const DELETE_INTEGRATIONS = 'DELETE_INTEGRATIONS';
const CLEAR_DELETED_FIELDS = 'CLEAR_DELETED_FIELDS';

export {
  DELETE_ACTIVITY_ADD_ONS,
  DELETE_ACTIVITY_MANDATORY_FEES,
  DELETE_RELATED_ACCOMMODATIONS,
  DELETE_RELATED_ACTIVITIES,
  DELETE_INTEGRATIONS,
  CLEAR_DELETED_FIELDS
};
